export default __webpack_public_path__ + "static/varios-live-internacional-75a753281f1a548b8cb680da8002d943.jpg";